import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.gray.gray90,
      borderRadius: theme.shape.borderRadius,
      position: 'relative',
      width: 'fit-content',
      display: 'flex',
      flexDirection: 'row',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
    },
    text: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      padding: theme.spacing(0.75),
    },
    improveScoreIcon: {
      marginLeft: theme.spacing(0.75),
      width: 16,
      height: 16,
    },
  }),
  { name: 'ImproveScoreBy' }
);
